<template>
  <div v-show="visible">
    <el-dialog title="生成报告" :close-on-click-modal="false" element-loading-background="rgba(255, 255,255,0.7)"
      :visible.sync="visible" :before-close="dialogClose" width="700px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="schoolName" label="学校名称">
              <el-input v-model="form.schoolName" :readonly="setReadonly" maxlength="15" placeholder=""
                style="width: 230px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phrase" label="校训短语">
              <el-input v-model="form.phrase" :readonly="setReadonly" maxlength="10" placeholder=""
                style="width: 230px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="title" label="报告标题">
              <el-input v-model="form.title" :readonly="setReadonly" maxlength="12" placeholder=""
                style="width: 230px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="termRang" label="学期范围">
              <el-input v-model="form.termRang" :readonly="setReadonly" maxlength="20" placeholder="如：2021 - 2022学年第一学期"
                style="width: 230px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="startDate" label="开始日期">
              <el-date-picker :readonly="setReadonly" style="width: 230px" v-model="form.startDate" type="date"
                placeholder="本学期开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="endDate" label="结束日期">
              <el-date-picker :readonly="setReadonly" style="width: 230px" v-model="form.endDate" type="date"
                placeholder="本学期结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="classId" label="生成班级">
          <el-cascader style="width: 560px" :disabled="setReadonly" :options="classes" v-model="form.classId"
            :props="props" collapse-tags clearable></el-cascader>
        </el-form-item>

        <el-form-item prop="warmPrompt" label="温馨提示">
          <el-input type="textarea" placeholder="非评语，班主任特别交代的话。如：假期期间不要到水库玩水，下学期开学日期为几月几日，等。" :rows="3"
            v-model="form.warmPrompt" maxlength="170" :readonly="setReadonly" show-word-limit>
          </el-input>
        </el-form-item>

        <el-form-item v-if="!showReport" prop="" label="上传成绩">
          <el-upload style="width: 560px" class="upload-demo" :action="uploadUrl" accept=".xlsx, .xls"
            :show-file-list="false" :auto-upload="true" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" v-loading="uploadLoading" type="primary">点击上传成绩</el-button>
            <!-- <div
              slot="tip"
              class="el-upload__tip"
              style="font-size: 12px; color: #bbbbbb"
            >
              根据模板格式填写成绩信息，然后再进行点击上传，注意点如下：<br />
              1、下载模板内容会自动生成班级学生、身份证、科目名称，请勿修改。<br />
              2、下载模板选中的班级与生成班级要对应起来，不然会生成报告失败。<br />
              3、请根据模板中的对应科目，填充考试成绩后，再进行上传。<br />
            </div> -->
          </el-upload>
        </el-form-item>

        <el-form-item v-if="showReport" prop="" label="临时报告">
          <el-button type="danger" @click="showReport = false; setReadonly = false; form.log = ''"">删除报告</el-button>
          <el-button type="primary" @click="setLook">查看报告</el-button>
        </el-form-item>

        <el-form-item prop="" label="生成日志">
          <el-input type="textarea" :rows="5" :readonly="true" style="width:560px;" v-model="form.log">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-loading="saveLoading" @click="save()">保存报告</el-button>
      </span>
    </el-dialog>

    <!-- 查看报告弹出框 -->
    <div v-if="addVisible">
      <LookReport ref="LookReport"></LookReport>
    </div>
  </div>
</template>

<script>
import http from "../../../common/http";
import LookReport from "./LookQualityReport.vue";
import io from "socket.io-client";

export default {
  data() {
    return {
      addVisible: false,
      visible: false,
      showReport: false,
      setReadonly: false,
      props: { checkStrictly: true },
      form: {
        deptId: "",
        classId: "",
        schoolName: "",
        phrase: "",
        title: "",
        termRang: "",
        startDate: "",
        endDate: "",
        warmPrompt: "",
        log: "",
      },
      rules: {
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
        phrase: [
          { required: true, message: "请输入校训短语", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入报告标题", trigger: "blur" }],
        termRang: [
          { required: true, message: "请输入学期范围", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请输入本学期开始日期", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请输入本学期结束日期", trigger: "blur" },
        ],
        classId: [
          { required: true, message: "请选择生成报告班级", trigger: "blur" },
        ],
      },
      uploadUrl: "",
      uploadLoading: false,
      saveLoading: false,
      classes: [],
      // socketio 配置信息
      socketIoClient: undefined,
      closeCurrentWindow: false,
    };
  },
  components: {
    LookReport,
  },
  created: function () { },
  mounted: function () { },
  methods: {
    init(deptId, host, sourceType) {
      this.visible = true;
      if (this.$refs["form"] != undefined) {
        this.$refs["form"].resetFields();
      }

      this.showReport = false;
      this.setReadonly = false;
      this.uploadLoading = false;
      this.saveLoading = false;

      this.form.log = "";
      this.form.processRecordSwitch = true;

      this.classes = [];
      this.form.deptId = deptId;
      // 初始数据
      this.getClass()
      this.getUUID()
      this.getInitData()
      this.connect(host, sourceType);
    },
    getName(setVal,data){
        // 角色、部门递归获取层级名称
        if(this.$util.isNotEmpty(data)){
            let valArr = setVal.split(",")
            let arr = new Array()
            for(let i = 0;i < valArr.length;i++){
                let tempArr = new Array()
                this.recursionCascader(valArr[i], data, tempArr, data)
                arr.push(tempArr.reverse())
            }
            return arr[0]
        }
    },
    recursionCascader(val, cdata, tempArr, data){
        if(val == 0){
            return
        }
        // 递归获取值
        for(let i=0; i<cdata.length;i++){
            if(cdata[i].value == val){
                tempArr.push(val)
                this.recursionCascader(cdata[i].parentId, data, tempArr, data)
            }
            if(cdata[i].children && cdata[i].children.length) {
                this.recursionCascader(val, cdata[i].children, tempArr, data)
            }
        }
    },
    // 获取开始日期与结束日期
    getStartAndEndDate() {
      let url = this.myCommentDraftBoxGetUrl
      let data = {}
      this.apiPost(url, data).then((res) => {
        if (res.status == 200) {
          this.form.startDate = res.data.startDate
          this.form.endDate = res.data.endDate
          // 班级不为空，默认填充
          if(this.$util.isNotEmpty(res.data.classId)){
              this.form.classId = this.getName(res.data.classId, this.classes)
          }
        } else {
          this.$commonFn.showTip(res.message, 3)
        }
      }, (err) => {
        console.log('获取开始日期与结束日期错误，原因是：', e)
      })
    },
    // 获取uuid
    getUUID() {
      // 获取UUID
      let url = this.getUUIDUrl
      let data = {}
      this.apiPost(url, data).then((res) => {
        if (res.status == 200) {
          this.form.id = res.data
          console.log(this.form.id)
        } else {
          this.$commonFn.showTip(res.message, 3)
        }
      }, (err) => {
        console.log(err)
      }
      )
    },
    // 获取班级
    getClass() {
      let url = this.getDeptCascaderUrl
      let data = {
        // deptId:this.form.deptId
      };
      this.apiPost(url, data).then(
        (res) => {
          if (res.status == 200) {
            this.classes = res.data.selects
            this.getStartAndEndDate()
          } else {
            this.$commonFn.showTip(res.message, 3)
          }
        }, (err) => {
          console.log(err)
        }
      )
    },
    // 获取模板配置数据
    getInitData() {
      let url = this.studencomprehensiveConfigListUrl;
      let data = {
        deptId: this.form.deptId,
      };
      this.apiPost(url, data).then(
        (res) => {
          if (res.status == 200) {
            // 渲染有数据值
            let resultData = res.data;
            for (let i = 0; i < resultData.length; i++) {
              let obj = resultData[i];

              if (obj.dictKey == "school_key") {
                // 学校
                this.form.schoolName = obj.dictVal;
              } else if (obj.dictKey == "phrase_key") {
                // 校训短语
                this.form.phrase = obj.dictVal;
              } else if (obj.dictKey == "title_key") {
                // 报告标题
                this.form.title = obj.dictVal;
              } else if (obj.dictKey == "warmPrompt_key") {
                // 温馨提示
                this.form.warmPrompt = obj.dictVal;
              }
            }
            // 根据当前月份生成学期范围
            let date = new Date();
            // 获取当前月份
            let month = date.getMonth() + 1;
            // 获取当前年份
            let fullYear = date.getFullYear();
            // console.log('当前年份：'+typeof(fullYear)+'，当前月份：'+typeof(month));
            console.log(month >= 1);
            if ((month >= 9 && month <= 12) || (month >= 1 && month <= 2)) {
              if (month >= 1 && month <= 2) {
                this.form.termRang =
                  "（" + (fullYear - 1) + " - " + fullYear + "学年第一学期）";
              } else {
                this.form.termRang =
                  "（" + fullYear + " - " + (fullYear + 1) + "学年第一学期）";
              }
            } else if (month >= 3 && month <= 8) {
              this.form.termRang =
                "（" + (fullYear - 1) + " - " + fullYear + "学年第二学期）";
            }
          } else {
            this.$commonFn.showTip(res.message, 3);
          }
        },
        (err) => {
          console.log(err);
          this.$commonFn.showTip(err, 3);
        }
      );
    },
    handleAvatarSuccess(res, file) {
      //this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let fileType = file.type
          let isLt2M = file.size / 1024 / 1024 < 100
          console.log("文件类型：" + fileType + ";文件大小：" + file.size)
          if (this.$constant.excelFileType.indexOf(fileType) == -1) {
            this.$commonFn.showTip("导入文件只支持.xls与.xlsx", 3)
            return false
          }

          if (!isLt2M) {
            this.$commonFn.showTip("文件大小不能超过100MB!", 3)
            return false
          }
          // 上传文件
          this.uploadLoading = true
          this.setReadonly = true
          // this.loadingText = "生成过程中时间比较久，请耐心等待...";
          let uploadForm = new FormData()
          uploadForm.append("file", file)
          uploadForm.append("id", this.form.id)
          uploadForm.append("classId", this.form.classId[this.form.classId.length - 1])
          uploadForm.append("schoolName", this.form.schoolName)
          uploadForm.append("phrase", this.form.phrase)
          uploadForm.append("title", this.form.title)
          uploadForm.append("termRang", this.form.termRang)
          uploadForm.append("startDate", this.form.startDate)
          uploadForm.append("endDate", this.form.endDate)
          uploadForm.append("warmPrompt", this.form.warmPrompt)
          uploadForm.append("socketIoSessionId", this.socketIoClient.id)

          this.$axios.post(this.studentComprehensiveReportCreateTempReportUrl, uploadForm).then(
            (res) => {
              if (res.data.status == 200) {
                // 成功不处理，由socketIo推送处理
              } else {
                this.uploadLoading = false
                this.showReport = false
                this.setReadonly = false
                this.$commonFn.showTip(res.data.message, 4, true)
              }
            }, (err) => {
              console.log(err)

              this.uploadLoading = false
              this.showReport = false
              this.setReadonly = false
              this.$commonFn.showTip("网络繁忙，请稍后重试，响应码(" + err.response.status + ")", 3)
            }
          );
        }
      });
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 必须先生成报告，然后再进行保存报告
          if (!this.showReport) {
            this.$commonFn.showTip(
              "请先上传成绩生成临时报告，确认后再进行报告提交",
              3
            );
            return;
          }

          let url = this.studentComprehensiveReportSaveQualityUrl;
          let data = {
            id: this.form.id,
            deptId: this.form.deptId,
            title: this.form.title,
            termRang: this.form.termRang,
            warmPrompt: this.form.warmPrompt,
            startDate: this.form.startDate,
            endDate: this.form.endDate,
            classId: this.form.classId[this.form.classId.length - 1],
            reportIdArr: this.form.reportIdArr,
          };

          this.saveLoading = true
          this.apiPost(url, data).then(
            (res) => {
              if (res.status === 200) {
                this.$commonFn.showTip(res.message, 1)
                this.visible = false
                this.$parent.getData()
              } else {
                this.$commonFn.showTip(res.message, 3)
              }
              this.saveLoading = false
            },
            (err) => {
              console.log(err)
              this.saveLoading = false
            }
          );
        }
      });
    },
    setLook() {
      // 查看报表
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs["LookReport"].init(this.form)
      });
    },
    // 连接socketIo
    connect(host, sourceType) {
      let that = this;
      // 关闭当前窗口
      this.closeCurrentWindow = false;

      let url = ""
      // 源类型：1-钉钉企业内部应用，2-钉钉第三方企业应用，3-微信应用
      if (sourceType === 2 || sourceType === 3 
            || host.indexOf('ibitedu.cn')>-1) {
        url = 'https://' + host
      } else {
        url = 'http://' + host + ':9092'
      }
      that.socketIoClient = io(url, {
        transports: ['websocket'],
        query: {
          socketIoType: 'generate'
        }
      });

      // 连接socketIo
      // const config = { url: 'http://' + host + ':9092' }
      // that.socketIoClient = socketio(config.url, { query: { socketIoType: 'generate' }, transports: ['websocket'] }) 

      // 连接成功，监听事件
      that.socketIoClient.on("connect", (socket) => {
        let sessionId = that.socketIoClient.id; // 获取session ID
        console.log("socketIoClient 连接服务成功")
        that.subscription(sessionId)
        console.log("sessionId", sessionId)
      })

      // 关闭连接，监听事件
      that.socketIoClient.on("disconnect", (socket) => {
        if (that.closeCurrentWindow) {
          console.log("手动关闭当前窗口，触发socketIoClient关闭连接")
        } else {
          console.log("后台关闭链路，触发socketIoClient关闭连接")
          that.uploadLoading = false
          that.showReport = false
          that.setReadonly = false
          that.$commonFn.showTip("网页连接已断开，请按下F5刷新界面重新尝试", 33)
        }

      })
    },
    // 订阅, 监听服务端推送过来的消息
    subscription(sessionId) {
      let that = this;
      that.socketIoClient.on(sessionId, function (data) {
        // console.log(data)
        // 如果内容存在reportIdArr，表示报文已结束
        if (data.indexOf("reportIdArr") > -1) {
          let obj = JSON.parse(data);
          that.form.reportIdArr = obj.reportIdArr;
          that.uploadLoading = false;
          that.showReport = true;
          that.setReadonly = true;
        } else {
          that.form.log = data + '\n' + that.form.log;
        }
      })
    },
    dialogClose(done) {
      // 关闭socket
      if(this.socketIoClient != undefined){
          this.closeCurrentWindow = true
          this.socketIoClient.close()
          console.log("dialogClose，触发socketIoClient关闭连接")
      }
      // 关闭窗口
      done()
      this.$reload
    },
  },
  destroyed() {
      // 关闭socket
      if(this.socketIoClient != undefined){
          this.closeCurrentWindow = true
          this.socketIoClient.close()
          console.log("destroyed，触发socketIoClient关闭连接")
      }
  },
  mixins: [http],
};
</script>

<style scoped>
/deep/ .el-upload--text {
  background-color: #fff;
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 107px;
  height: 35px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/CreateQualityReport.vue